
import PropTypes from 'prop-types'
import { Grid, Typography } from '@mui/material'

const SubmissionAlreadyCompleted = ({ errorMessage }) => {
  const isAuto = errorMessage && errorMessage.includes('auto')

  return (
    <Grid
      sx={{
        maxWidth: 300
      }}
      container spacing={3}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: 'bold'
          }}
          gutterBottom variant="h4" align="center">
          {isAuto ? 'Auto Submission Completed' : 'Submission Completed'}
        </Typography>
        <Typography gutterBottom variant="body1" align="center">
          {isAuto
            ? `An automated submission stating that your vehicle was available for private use all month has been recorded. Please contact your fleet controller if changes are required.`
            : `You have already recorded a submission for the month. If you do need to make changes to this please contact your fleet controller.`
          }
        </Typography>
      </Grid>
    </Grid>
  )
}

SubmissionAlreadyCompleted.propTypes = {
  errorMessage: PropTypes.string,
}

export default SubmissionAlreadyCompleted
